import angular from 'angular';

import tippyDirective from './tippy.directive';

import './tippy.sass';

angular.module('tct.tippy', [])
  .directive('tctTippy', tippyDirective);
